import {
  transformExportParamsToCrudApi,
  transformParamsToCrudApi,
} from '@app/core/crud/listing-adapter';
import { convertGetManyResponse } from '@app/core/crud/response-converter';
import { ListView } from '@app/core/list-view/ListView';
import { ListViewExportParams, ListViewQueryParams } from '@app/core/list-view/types';
import { AodRule } from '@app/modules/audit/modules/aod/aod.types';
import {
  auditReportsListAodRules,
  getApiV2Client,
  getAuditReportsExportAodRulesUrl,
} from '@mi-front/api-v2';
import { Paginated } from '@mi-front/core';
import { AodRulesList } from './AodRulesList';
import { CreateRuleButton } from './CreateRuleButton';
import { AOD_RULES_FILTERS_CONFIG } from './filter-config';

export function AodRulesListPage_v2() {
  const queryFn = async (
    params: ListViewQueryParams,
  ): Promise<Paginated<AodRule> | ArrayBuffer> => {
    const processedParams = transformParamsToCrudApi(params);

    const response = await auditReportsListAodRules(processedParams);
    return await convertGetManyResponse(response);
  };

  const exportFn = async (params: ListViewExportParams) => {
    return getApiV2Client().request<ArrayBuffer>('GET', getAuditReportsExportAodRulesUrl().url, {
      params: transformExportParamsToCrudApi(params),
      responseType: 'arraybuffer',
    });
  };

  return (
    <ListView
      listId="AodRulesList-v2"
      queryFn={queryFn}
      exportFn={exportFn}
      filters={AOD_RULES_FILTERS_CONFIG}
      actions={[<CreateRuleButton key="create-rule" />]}
      ListComponent={AodRulesList}
    />
  );
}
